import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueInputMask from "vue-inputmask";
import VueScrollTo from "vue-scrollto";
import VueTables from "@alexrafael10/vue-tables-2";
import VTooltip from "v-tooltip";
import VueRouter from "vue-router";
import NoResultsRow from "../../../components/general/no-results-row";
import checkView from "vue-check-view";
import VCalendar from "v-calendar";
import Auth from "./custom-plugins/auth";
import VueCompositionAPI from "@vue/composition-api";
import PrettyCheckbox from "pretty-checkbox-vue";
import PortalVue from "portal-vue";
import { WebsocketPlugin } from "./custom-plugins/websocket";
export default Vue => {
  Vue.use(VueCompositionAPI);
  Vue.use(Auth);
  Vue.use(BootstrapVue, {
    breakpoints: ["xs", "sm", "md", "lg", "xl", "xxl"]
  });
  Vue.use(IconsPlugin);
  Vue.use(checkView);
  Vue.use(VueInputMask.default);
  Vue.use(VueScrollTo);
  Vue.use(VueTables.ClientTable, {
    resizableColumns: false
  }, false, "bootstrap3", {
    noResultsRow: NoResultsRow
  });
  Vue.use(VueTables.ServerTable, {
    resizableColumns: false
  }, false, "bootstrap3", {
    noResultsRow: NoResultsRow
  });
  Vue.use(VTooltip);
  Vue.use(VueRouter);
  Vue.use(VCalendar);
  Vue.use(WebsocketPlugin);
  Vue.use(PrettyCheckbox);
  Vue.use(PortalVue);
};